import { Socket } from 'phoenix'
import { createContext, PropsWithChildren, useMemo } from 'react'
import { ManagedSocketOptions, useManagedSocket } from './useManagedSocket'

interface PresenceSocketContextValue {
  socket: Socket | null
}

interface ProviderProps {
  enabled?: boolean
  url: string
  /**
   * If you need to authenticate your socket connection, set the authToken option here,
   * along with `refreshAuthToken` so a reconnect isn't refused with a rotated-away token.
   */
  options?: ManagedSocketOptions
}

export const PresenceSocketContext = createContext<PresenceSocketContextValue>({
  socket: null,
})

/**
 * Socket connection dedicated to relay's `/presence` endpoint.
 */
export const PresenceSocketProvider = ({
  children,
  enabled,
  url,
  options,
}: PropsWithChildren<ProviderProps>) => {
  const socket = useManagedSocket(url, options, enabled)

  const value = useMemo(() => ({ socket }), [socket])

  return (
    <PresenceSocketContext.Provider value={value}>
      {children}
    </PresenceSocketContext.Provider>
  )
}
